import React, { useState, useEffect } from 'react';

import {
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography
} from '@material-ui/core';

import DialogButton from './DialogButton';
import SelectTextField from '../SelectTextField';

import { ProjectDescription } from '../../../../redux/project/projectTypes';

interface IProps {
    open: boolean;
    onClose: () => void;
    onAction: (dstColumn: number) => void;
    title: string;
    icon?: any;
    lists: ProjectDescription[] | null;
}

function MoveDialog({ open, onClose, onAction, lists, title, icon }: IProps) {
    const [columnId, setColumnId] = useState<number>(0);

    useEffect(() => {
        if (lists !== null) setColumnId(lists[0].id);
    }, [lists]);

    function handleMove() {
        onAction(columnId);
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <DialogTitle disableTypography>
                {icon}
                <Typography variant="h4">{title}</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <SelectTextField
                    fullWidth
                    label="List"
                    tooltip="You can select any of your lists in your workspace to save the site card to."
                    value={columnId}
                    onChange={e => setColumnId(Number(e.target.value))}>
                    {lists !== null &&
                        lists.map(column => (
                            <MenuItem key={column.id} value={column.id}>
                                {column.title}
                            </MenuItem>
                        ))}
                </SelectTextField>
            </DialogContent>
            <DialogActions>
                <DialogButton variant="contained" onClick={handleMove}>
                    Save
                </DialogButton>
                <DialogButton onClick={onClose} variant="outlined">
                    Cancel
                </DialogButton>
            </DialogActions>
        </Dialog>
    );
}

export default MoveDialog;
